import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { useTranslation } from "../i18n";

const SITE_NAME = "Delyth Brides";

type SeoProps = {
  /** Full text for the browser tab (include branding as you prefer). */
  pageTitle: string;
  description?: string;
};

const Seo: React.FC<SeoProps> = ({
  pageTitle,
  description,
}) => {
  const location = useLocation();
  const { locale, t } = useTranslation();
  const origin =
    typeof window !== "undefined" ? window.location.origin : "";
  const canonicalUrl = `${origin}${location.pathname}${location.search}`;
  const imageUrl = origin ? `${origin}/logo512.png` : "";
  const resolvedDescription = description ?? t("seo.defaultDescription");
  const ogLocale = locale === "fr" ? "fr_FR" : "en_UG";

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={resolvedDescription} />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content={ogLocale} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={resolvedDescription} />
      <meta property="og:url" content={canonicalUrl} />
      {imageUrl ? (
        <meta property="og:image" content={imageUrl} />
      ) : null}
      {imageUrl ? (
        <meta
          property="og:image:alt"
          content={`${SITE_NAME} — bespoke bridal dresses`}
        />
      ) : null}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={resolvedDescription} />
      {imageUrl ? (
        <meta name="twitter:image" content={imageUrl} />
      ) : null}
    </Helmet>
  );
};

export default Seo;
